/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_LabelInputs */

const en_layout_label = /** @type {(inputs: Layout_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layout`)
};

const de_layout_label = /** @type {(inputs: Layout_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansicht`)
};

/**
* | output |
* | --- |
* | "Layout" |
*
* @param {Layout_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const layout_label = /** @type {((inputs?: Layout_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_layout_label(inputs)
	return en_layout_label(inputs)
});